import { formatTime, isEventPast, isWorkshopPast, workshopDateRange, pillLabel, spaceLabel } from "./calendarUtils";

export function EventPill({ event, onClick, compact, adminMode, cancelled, dateStr }) {
  const isPrivate = event._isPrivate === true;
  const isOnline  = event.venue === "venue_online";
  const isHybrid  = event.isHybrid === true;
  const past      = !adminMode && dateStr ? isEventPast(dateStr, event.time, event.duration) : false;
  const clickable = adminMode || (!cancelled && !past);
  const label     = pillLabel(event);

  return (
    <button
      onClick={() => { if (clickable) onClick(event); }}
      data-subj={isPrivate ? undefined : (event.subject || "")}
      className={`event-pill ${isPrivate?"private":isHybrid?"hybrid":isOnline?"online":"inperson"} ${compact?"compact":""} ${cancelled?"cancelled-pill":""} ${adminMode?"admin-pill":""} ${past && !adminMode?"past-pill":""}`}
      style={!clickable ? {cursor:"default", pointerEvents:"none"} : {}}
    >
      <span className="event-time">{formatTime(event.time)}</span>
      <span className={`event-tag ${isPrivate?"tag-private":isHybrid?"tag-hybrid":isOnline?"tag-online":"tag-studio"}`}>
        {cancelled?"Cancelled":isPrivate?(event._isBlock ? event.title : "Private"):isHybrid?"Hybrid":isOnline?"Online":"Studio"}
      </span>
      {label && <span className="event-title">{label}</span>}
      {event._space && !cancelled && !past && !adminMode && (
        <span className={`event-space${event._space.full ? " event-space--full" : ""}`}>{spaceLabel(event._space, true)}</span>
      )}
    </button>
  );
}

export function WorkshopBanner({ workshop, dateStr, onClick, adminMode }) {
  const allDates  = workshopDateRange(workshop);
  const isFirst   = allDates[0] === dateStr;
  const isLast    = allDates[allDates.length - 1] === dateStr;
  const dayData   = workshop.days.find(d => d.date === dateStr);
  const sessCount = dayData?.sessions?.length ?? 0;
  const past      = !adminMode && isWorkshopPast(workshop);

  return (
    <button
      onClick={() => { if (past && !adminMode) return; onClick(workshop); }}
      data-subj={workshop.subject || ""}
      className={`workshop-banner ${isFirst?"ws-first":""} ${isLast?"ws-last":""} ${past && !adminMode?"past-pill":""}`}
      style={past && !adminMode ? {cursor:"default", pointerEvents:"none"} : {}}
      title={workshop.title}
    >
      {isFirst
        ? <span className="ws-banner-title">{workshop.title}</span>
        : sessCount > 0 && <span className="ws-banner-sessions">{sessCount} session{sessCount!==1?"s":""}</span>
      }
    </button>
  );
}